<template>
  <div>
    <v-container fluid class="px-3 py-3">
      <v-row>
        <v-col cols="12">
          <v-card class="card-shadow border-radius-xl">
            <div class="px-4 py-4">
              <v-row align="center">
                <v-col cols="3" sm="auto">
                  <h5 class="text-h5 font-weight-bold text-typo mb-0">
                    行事曆
                  </h5>
                </v-col>
                <v-col cols="9" sm="auto" class="d-flex align-center">
                  <v-switch
                    v-if="rootRole"
                    v-model="template"
                    label="公版"
                    @change="fetchHolidays"
                    color="blue"
                    hide-details
                    class="mt-0 mr-3"
                  ></v-switch>
                  <h5 class="text-h6 text-body mb-0">
                    <span class="text-danger"
                      >現在編輯 : {{ editingTargetText }}</span
                    >
                  </h5>
                </v-col>
                <v-col
                  cols="12"
                  md="auto"
                  class="ms-md-auto d-flex flex-wrap align-center justify-end"
                >
                  <v-btn
                    v-if="false"
                    class="
                      font-weight-bold
                      text-uppercase
                      btn-primary
                      bg-gradient-warning
                      py-2
                      px-6
                      me-2
                      mb-2 mb-sm-0
                    "
                    @click="openMakeUpDayDialog"
                    elevation="0"
                  >
                    <v-icon left small>mdi-calendar-clock</v-icon>
                    新增補班
                  </v-btn>
                  <v-btn
                    v-if="!editMode"
                    class="
                      font-weight-bold
                      text-uppercase
                      btn-primary
                      bg-gradient-default
                      py-2
                      px-6
                      me-2
                      mb-2 mb-sm-0
                    "
                    @click="uploadDialog = true"
                    elevation="0"
                  >
                    <v-icon left small>mdi-upload</v-icon>
                    上傳檔案
                  </v-btn>
                  <v-btn
                    v-if="!editMode"
                    class="
                      font-weight-bold
                      text-uppercase
                      btn-primary
                      bg-gradient-info
                      py-2
                      px-6
                      me-2
                      mb-2 mb-sm-0
                    "
                    @click="enterEditMode"
                    elevation="0"
                  >
                    <v-icon left small>mdi-pencil</v-icon>
                    編輯
                  </v-btn>
                  <v-btn
                    v-if="editMode"
                    class="
                      font-weight-bold
                      text-uppercase
                      btn-primary
                      bg-gradient-primary
                      py-2
                      px-6
                      me-2
                      mb-2 mb-sm-0
                    "
                    @click="saveChanges"
                    :loading="saving"
                    elevation="0"
                  >
                    <v-icon left small>mdi-content-save</v-icon>
                    儲存
                  </v-btn>
                  <v-btn
                    v-if="editMode"
                    class="
                      font-weight-bold
                      text-uppercase
                      btn-secondary
                      bg-gradient-light
                      py-2
                      px-6
                      me-2
                      mb-2 mb-sm-0
                    "
                    @click="cancelEdit"
                    elevation="0"
                  >
                    <v-icon left small>mdi-close</v-icon>
                    取消
                  </v-btn>
                  <v-select
                    v-model="selectedYear"
                    :items="availableYears"
                    label="年度"
                    outlined
                    dense
                    hide-details
                    class="year-selector mt-2 mt-md-0 ml-md-2"
                    style="max-width: 150px; min-width: 120px"
                    @change="fetchHolidays"
                    :disabled="editMode"
                  ></v-select>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" v-if="holidayFetchError">
          <v-alert
            type="warning"
            text
            dense
            color="orange"
            icon="mdi-alert"
            class="border-radius-xl card-shadow mb-0"
          >
            {{ holidayFetchError }}
          </v-alert>
        </v-col>
        <v-col cols="12" lg="9">
          <v-card class="card-shadow border-radius-xl">
            <div class="px-4 py-4">
              <full-calendar
                :options="calendarOptions"
                ref="fullCalendar"
              ></full-calendar>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" lg="3">
          <v-card class="card-shadow border-radius-xl">
            <div class="px-4 pt-4">
              <h6 class="text-h6 font-weight-bold text-typo">假日列表</h6>
            </div>
            <div class="px-4 pt-4 pb-3">
              <v-list v-if="holidays.length > 0">
                <v-list-item-group class="border-radius-sm">
                  <v-list-item
                    :ripple="false"
                    v-for="(item, i) in upcomingHolidays"
                    :key="i"
                    class="px-0 border-radius-sm"
                    :class="i < upcomingHolidays.length - 1 ? 'mb-4' : ' '"
                  >
                    <v-avatar
                      size="50"
                      class="text-white border-radius-md px-2 py-2 me-4"
                      :color="item.color"
                    >
                      <v-icon
                        :class="`text-gradient text-` + item.iconColor"
                        size="18"
                        >{{ item.icon }}</v-icon
                      >
                    </v-avatar>
                    <v-list-item-content class="py-0">
                      <div class="d-flex flex-column">
                        <h6 class="mb-1 text-dark text-sm font-weight-bold">
                          {{ item.title }}
                        </h6>
                        <span class="text-sm text-body">
                          {{ item.date }}
                        </span>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <div v-else class="text-center py-4">
                <p class="text-sm text-secondary">暫無假日資料</p>
              </div>
            </div>
          </v-card>

          <v-card class="card-shadow border-radius-xl mt-6">
            <div class="px-4 pt-4 pb-4">
              <h6 class="text-h6 font-weight-bold text-typo mb-4">圖例</h6>
              <div class="d-flex flex-column">
                <div class="d-flex align-center mb-3">
                  <div class="legend-box bg-gradient-danger me-3"></div>
                  <span class="text-sm">國定假日</span>
                </div>
                <div class="d-flex align-center">
                  <div class="legend-box weekend-tip me-3"></div>
                  <span class="text-sm">週末</span>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Upload Dialog -->
    <v-dialog v-model="uploadDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="text-h5 font-weight-bold">
          上傳假日檔案
          <v-spacer></v-spacer>
          <v-btn icon @click="closeUploadDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="uploadForm">
            <v-text-field
              v-model="uploadForm.name"
              label="假日名稱 *"
              outlined
              dense
              :rules="[(v) => !!v || '請輸入假日名稱']"
              placeholder="例如: 114"
              required
            ></v-text-field>

            <v-file-input
              v-model="uploadForm.csvFile"
              label="CSV 檔案 *"
              outlined
              dense
              accept=".csv"
              :rules="[(v) => !!v || '請選擇 CSV 檔案']"
              prepend-icon=""
              prepend-inner-icon="mdi-file-delimited"
              show-size
              required
            ></v-file-input>

            <v-textarea
              v-model="uploadForm.extra"
              label="備註"
              outlined
              dense
              rows="3"
              placeholder="選填"
            ></v-textarea>
            <!-- hint -->
            <p class="text-sm text-body mt-2">
              資料來源: 中華民國政府行政機關辦公日曆表
              <a href="https://data.gov.tw/dataset/14718" target="_blank"
                >https://data.gov.tw/dataset/14718</a
              >
            </p>
          </v-form>

          <v-alert
            v-if="uploadError"
            type="error"
            dense
            dismissible
            @input="uploadError = null"
            class="mt-3"
          >
            {{ uploadError }}
          </v-alert>

          <v-alert
            v-if="uploadSuccess"
            type="success"
            dense
            dismissible
            @input="uploadSuccess = false"
            class="mt-3"
          >
            假日檔案上傳成功！
          </v-alert>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            @click="closeUploadDialog"
            :disabled="uploading"
          >
            取消
          </v-btn>
          <v-btn
            class="
              font-weight-bold
              text-uppercase
              btn-primary
              bg-gradient-primary
              py-2
              px-6
              me-3
            "
            @click="uploadHolidayFile"
            :loading="uploading"
            :disabled="uploading"
          >
            上傳
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Event Dialog (Add/Edit) -->
    <v-dialog v-model="eventDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="text-h5 font-weight-bold">
          {{ editingEventIndex !== null ? "編輯假日" : "新增假日" }}
          <v-spacer></v-spacer>
          <v-btn icon @click="closeEventDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="eventForm">
            <v-text-field
              v-model="eventForm.name"
              label="假日名稱 *"
              outlined
              dense
              :rules="[(v) => !!v || '請輸入假日名稱']"
              required
            ></v-text-field>

            <v-text-field
              v-model="eventForm.original_date"
              label="原始日期 (YYYYMMDD) *"
              outlined
              dense
              :rules="[
                (v) => !!v || '請輸入日期',
                (v) => /^\d{8}$/.test(v) || '日期格式必須為 YYYYMMDD',
              ]"
              placeholder="例如: 20250101"
              required
            ></v-text-field>

            <v-text-field
              v-model="eventForm.actual_date"
              label="實際日期 (YYYYMMDD) *"
              outlined
              dense
              :rules="[
                (v) => !!v || '請輸入日期',
                (v) => /^\d{8}$/.test(v) || '日期格式必須為 YYYYMMDD',
              ]"
              placeholder="例如: 20250101"
              required
            ></v-text-field>

            <v-textarea
              v-model="eventForm.comment"
              label="備註"
              outlined
              dense
              rows="3"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-btn
            v-if="editingEventIndex !== null"
            class="
              font-weight-bold
              text-uppercase
              btn-danger
              bg-gradient-danger
              py-2
              px-6
            "
            @click="deleteEvent"
            elevation="0"
          >
            <v-icon left small>mdi-delete</v-icon>
            刪除
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            @click="closeEventDialog"
          >
            取消
          </v-btn>
          <v-btn
            class="
              font-weight-bold
              text-uppercase
              btn-primary
              bg-gradient-primary
              py-2
              px-6
              me-3
            "
            @click="saveEvent"
          >
            {{ editingEventIndex !== null ? "更新" : "新增" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Make Up Day Dialog (Add/Edit) -->
    <v-dialog v-model="makeUpDayDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="text-h5 font-weight-bold">
          {{ editingMakeUpDayIndex !== null ? "編輯補班" : "新增補班" }}
          <v-spacer></v-spacer>
          <v-btn icon @click="closeMakeUpDayDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="makeUpDayForm">
            <v-text-field
              v-model="makeUpDayForm.name"
              label="補班名稱 *"
              outlined
              dense
              :rules="[(v) => !!v || '請輸入補班名稱']"
              required
            ></v-text-field>

            <v-text-field
              v-model="makeUpDayForm.original_date"
              label="原始日期 (YYYYMMDD) *"
              outlined
              dense
              :rules="[
                (v) => !!v || '請輸入日期',
                (v) => /^\d{8}$/.test(v) || '日期格式必須為 YYYYMMDD',
              ]"
              placeholder="例如: 20250101"
              required
            ></v-text-field>

            <v-text-field
              v-model="makeUpDayForm.actual_date"
              label="實際日期 (YYYYMMDD) *"
              outlined
              dense
              :rules="[
                (v) => !!v || '請輸入日期',
                (v) => /^\d{8}$/.test(v) || '日期格式必須為 YYYYMMDD',
              ]"
              placeholder="例如: 20250101"
              required
            ></v-text-field>

            <v-text-field
              v-model="makeUpDayForm.hour"
              label="時數 *"
              outlined
              dense
              type="number"
              :rules="[
                (v) => (v !== '' && v !== null) || '請輸入時數',
                (v) => !isNaN(parseFloat(v)) || '請輸入有效的數字',
              ]"
              placeholder="例如: 8"
              required
            ></v-text-field>

            <v-textarea
              v-model="makeUpDayForm.comment"
              label="備註"
              outlined
              dense
              rows="3"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-btn
            v-if="editingMakeUpDayIndex !== null"
            class="
              font-weight-bold
              text-uppercase
              btn-danger
              bg-gradient-danger
              py-2
              px-6
            "
            @click="deleteMakeUpDay"
            elevation="0"
          >
            <v-icon left small>mdi-delete</v-icon>
            刪除
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            @click="closeMakeUpDayDialog"
          >
            取消
          </v-btn>
          <v-btn
            class="
              font-weight-bold
              text-uppercase
              btn-primary
              bg-gradient-primary
              py-2
              px-6
              me-3
            "
            @click="saveMakeUpDay"
          >
            {{ editingMakeUpDayIndex !== null ? "更新" : "新增" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import zhTwLocale from "@fullcalendar/core/locales/zh-tw";
import httpClient from "@/utils/httpClient";

export default {
  name: "Holiday",
  components: {
    FullCalendar,
  },
  data() {
    return {
      selectedYear: new Date().getFullYear(),
      availableYears: [],
      template: false,
      holidays: [],
      holidayData: null,
      uploadDialog: false,
      uploading: false,
      uploadError: null,
      uploadSuccess: false,
      holidayFetchError: null,
      uploadForm: {
        name: "",
        csvFile: null,
        extra: "",
      },
      currentMonth: new Date().getMonth(),
      currentYear: new Date().getFullYear(),
      editMode: false,
      saving: false,
      editedHolidays: [],
      originalHolidays: [],
      eventDialog: false,
      eventForm: {
        name: "",
        original_date: "",
        actual_date: "",
        comment: "",
      },
      editingEventIndex: null,
      makeUpDays: [],
      editedMakeUpDays: [],
      originalMakeUpDays: [],
      makeUpDayDialog: false,
      makeUpDayForm: {
        name: "",
        original_date: "",
        actual_date: "",
        hour: "",
        comment: "",
      },
      editingMakeUpDayIndex: null,
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        locale: zhTwLocale,
        contentHeight: "auto",
        initialView: "dayGridMonth",
        selectable: false,
        editable: false,
        headerToolbar: {
          start: "title",
          center: "",
          end: "today prev,next",
        },
        events: [],
        dayCellClassNames: (arg) => {
          return this.getDayCellClass(arg.date);
        },
        datesSet: (dateInfo) => {
          this.handleDateChange(dateInfo);
        },
        eventClick: (info) => {
          if (this.editMode) {
            this.handleEventClick(info);
          }
        },
        dateClick: (info) => {
          if (this.editMode) {
            this.handleDateClick(info);
          }
        },
      },
    };
  },
  computed: {
    ...mapGetters("company", ["companies", "selectedCompany"]),
    ...mapGetters("user", ["rootRole"]),
    editingTargetText() {
      if (this.template) return "公版";
      return this.selectedCompany && this.selectedCompany.company_name
        ? this.selectedCompany.company_name
        : "公司";
    },
    company_id() {
      return this.selectedCompany ? this.selectedCompany.id : 1;
    },
    upcomingHolidays() {
      if (!this.holidays || this.holidays.length === 0) return [];

      // Get the first day of the current displayed month
      const monthStart = new Date(this.currentYear, this.currentMonth, 1);
      monthStart.setHours(0, 0, 0, 0);

      // Get the last day of the current displayed month
      const monthEnd = new Date(this.currentYear, this.currentMonth + 1, 0);
      monthEnd.setHours(23, 59, 59, 999);

      return this.holidays
        .map((holiday) => {
          const dateStr = holiday.actual_date || holiday.original_date;
          const year = parseInt(dateStr.substring(0, 4));
          const month = parseInt(dateStr.substring(4, 6)) - 1;
          const day = parseInt(dateStr.substring(6, 8));
          const holidayDate = new Date(year, month, day);

          return {
            ...holiday,
            dateObj: holidayDate,
            title: holiday.name,
            date: this.formatDate(holidayDate),
            icon: "ni ni-calendar-grid-58",
            iconColor: "danger",
            color: "#fff8f8",
          };
        })
        .filter(
          (holiday) =>
            holiday.dateObj >= monthStart && holiday.dateObj <= monthEnd
        )
        .sort((a, b) => a.dateObj - b.dateObj);
    },
  },
  watch: {
    selectedCompany(newVal, oldVal) {
      if (!this.template && newVal && (!oldVal || newVal.id !== oldVal.id)) {
        this.fetchHolidays();
      }
    },
  },
  mounted() {
    this.initializeYears();
    // Default 公版(template) to true for rootRole users
    this.template = this.rootRole;
    this.fetchHolidays();
  },
  methods: {
    initializeYears() {
      const currentYear = new Date().getFullYear();
      for (let i = currentYear - 2; i <= currentYear + 2; i++) {
        this.availableYears.push(i);
      }
    },

    async fetchHolidays() {
      this.holidayFetchError = null;
      try {
        console.log(this.selectedYear);
        console.log(this.company_id);
        const url = this.template
          ? `/api/holidays/year/${this.selectedYear}?template=1`
          : `/api/holidays/year/${this.selectedYear}?company_id=${this.company_id}`;
        const response = await httpClient.get(
          // `/api/holidays/year/${this.selectedYear}?company_id=${this.company_id}`
          url
        );

        if (response.data) {
          this.holidayData = response.data;
          this.holidays = response.data.holidays || [];
          this.makeUpDays = response.data.make_up_day || [];
          this.updateCalendarEvents();

          // Navigate calendar to the selected year while keeping the same month
          if (this.$refs.fullCalendar) {
            const calendarApi = this.$refs.fullCalendar.getApi();
            const targetDate = new Date(
              this.selectedYear,
              this.currentMonth,
              1
            );
            calendarApi.gotoDate(targetDate);
          }
        }
      } catch (error) {
        console.error("Failed to fetch holidays:", error);
        this.holidays = [];
        this.makeUpDays = [];
        this.holidayData = null;
        if (error.response && error.response.status === 404) {
          this.holidayFetchError = "還未設定假期";
        }
        this.updateCalendarEvents();
      }
    },

    updateCalendarEvents() {
      const events = [];

      if (this.holidays && this.holidays.length > 0) {
        this.holidays.forEach((holiday) => {
          const dateStr = holiday.actual_date || holiday.original_date;
          const year = dateStr.substring(0, 4);
          const month = dateStr.substring(4, 6);
          const day = dateStr.substring(6, 8);
          const formattedDate = `${year}-${month}-${day}`;

          events.push({
            title: holiday.name,
            start: formattedDate,
            end: formattedDate,
            className: "bg-gradient-danger",
            extendedProps: {
              isHoliday: true,
              comment: holiday.comment,
            },
          });
        });
      }

      if (this.makeUpDays && this.makeUpDays.length > 0) {
        this.makeUpDays.forEach((makeUpDay) => {
          const dateStr = makeUpDay.actual_date || makeUpDay.original_date;
          const year = dateStr.substring(0, 4);
          const month = dateStr.substring(4, 6);
          const day = dateStr.substring(6, 8);
          const formattedDate = `${year}-${month}-${day}`;

          events.push({
            title: makeUpDay.name,
            start: formattedDate,
            end: formattedDate,
            className: "bg-gradient-info make-up-day-event",
            extendedProps: {
              isMakeUpDay: true,
              hour: makeUpDay.hour,
              comment: makeUpDay.comment,
            },
          });
        });
      }

      this.calendarOptions.events = events;
    },

    getDayCellClass(date) {
      const classes = [];
      const dayOfWeek = date.getDay();

      // Check if it's a weekend (Saturday = 6, Sunday = 0)
      if (dayOfWeek === 0 || dayOfWeek === 6) {
        classes.push("weekend-day");
      }

      // Check if it's a holiday
      const dateStr = this.formatDateToYYYYMMDD(date);
      const isHoliday = this.holidays.some(
        (holiday) => (holiday.actual_date || holiday.original_date) === dateStr
      );

      if (isHoliday) {
        classes.push("holiday-day");
      }

      return classes;
    },

    formatDateToYYYYMMDD(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}${month}${day}`;
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}年${month}月${day}日`;
    },

    handleDateChange(dateInfo) {
      // Update current month and year when calendar view changes
      const viewDate = dateInfo.view.currentStart;
      const newMonth = viewDate.getMonth();
      const newYear = viewDate.getFullYear();
      const yearChanged = newYear !== this.currentYear;

      this.currentMonth = newMonth;
      this.currentYear = newYear;

      if (yearChanged) {
        if (!this.availableYears.includes(newYear)) {
          this.availableYears.push(newYear);
          this.availableYears.sort((a, b) => a - b);
        }
        this.selectedYear = newYear;
        this.fetchHolidays();
      }
    },

    closeUploadDialog() {
      this.uploadDialog = false;
      this.uploadError = null;
      this.uploadSuccess = false;
      this.uploadForm = {
        name: "",
        csvFile: null,
        extra: "",
      };
      if (this.$refs.uploadForm) {
        this.$refs.uploadForm.resetValidation();
      }
    },

    async uploadHolidayFile() {
      // Validate form
      if (!this.$refs.uploadForm.validate()) {
        return;
      }

      if (!this.uploadForm.name || !this.uploadForm.csvFile) {
        this.uploadError = "請填寫所有必填欄位";
        return;
      }

      this.uploading = true;
      this.uploadError = null;
      this.uploadSuccess = false;

      try {
        // Create FormData for multipart/form-data request
        const formData = new FormData();
        formData.append("csv_file", this.uploadForm.csvFile);
        formData.append("name", this.uploadForm.name);
        formData.append("extra", this.uploadForm.extra || "");

        // Use axios directly for FormData upload
        const response = await httpClient.instance.post(
          "/api/holidays",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data) {
          this.uploadSuccess = true;

          // Refresh holidays list after successful upload
          setTimeout(() => {
            this.fetchHolidays();
            this.closeUploadDialog();
          }, 1500);
        }
      } catch (error) {
        console.error("Failed to upload holiday file:", error);
        this.uploadError =
          error.response?.data?.error || "上傳失敗，請稍後再試";
      } finally {
        this.uploading = false;
      }
    },

    enterEditMode() {
      this.editMode = true;
      this.originalHolidays = JSON.parse(JSON.stringify(this.holidays));
      this.editedHolidays = JSON.parse(JSON.stringify(this.holidays));
      this.originalMakeUpDays = JSON.parse(JSON.stringify(this.makeUpDays));
      this.editedMakeUpDays = JSON.parse(JSON.stringify(this.makeUpDays));

      // Enable date clicking in edit mode
      this.calendarOptions.selectable = true;
    },

    cancelEdit() {
      this.editMode = false;
      this.holidays = JSON.parse(JSON.stringify(this.originalHolidays));
      this.editedHolidays = [];
      this.makeUpDays = JSON.parse(JSON.stringify(this.originalMakeUpDays));
      this.editedMakeUpDays = [];
      this.updateCalendarEvents();

      // Disable date clicking
      this.calendarOptions.selectable = false;
    },

    async saveChanges() {
      if (!this.holidayData || !this.holidayData.id) {
        alert("無法儲存：缺少假日資料 ID");
        return;
      }

      this.saving = true;

      try {
        // Use holidays in the correct format and sort by original_date
        const holidaysForAPI = this.editedHolidays
          .map((holiday) => ({
            name: holiday.name,
            original_date: holiday.original_date,
            actual_date: holiday.actual_date,
            comment: holiday.comment || "",
          }))
          .sort((a, b) => a.original_date.localeCompare(b.original_date));

        const makeUpDaysForAPI = this.editedMakeUpDays
          .map((makeUpDay) => ({
            name: makeUpDay.name,
            original_date: makeUpDay.original_date,
            actual_date: makeUpDay.actual_date,
            hour: parseFloat(makeUpDay.hour),
            comment: makeUpDay.comment || "",
          }))
          .sort((a, b) => a.original_date.localeCompare(b.original_date));

        const payload = {
          name: this.holidayData.name,
          holidays: holidaysForAPI,
          make_up_day: makeUpDaysForAPI,
          extra: this.holidayData.extra || {},
        };

        const response = await httpClient.put(
          `/api/holidays/${this.holidayData.id}`,
          payload
        );

        if (response.data) {
          this.editMode = false;
          this.holidays = this.editedHolidays;
          this.originalHolidays = [];
          this.editedHolidays = [];
          this.makeUpDays = this.editedMakeUpDays;
          this.originalMakeUpDays = [];
          this.editedMakeUpDays = [];
          this.calendarOptions.selectable = false;

          // Refresh data
          await this.fetchHolidays();

          alert("假日資料已成功更新！");
        }
      } catch (error) {
        console.error("Failed to save holidays:", error);
        alert(error.response?.data?.error || "儲存失敗，請稍後再試");
      } finally {
        this.saving = false;
      }
    },

    handleDateClick(info) {
      // Open dialog to add new event
      const dateStr = info.dateStr.replace(/-/g, "");
      this.eventForm = {
        name: "",
        original_date: dateStr,
        actual_date: dateStr,
        comment: "",
      };
      this.editingEventIndex = null;
      this.eventDialog = true;
    },

    handleEventClick(info) {
      const dateStr = info.event.startStr.replace(/-/g, "");

      // Check if it's a makeUpDay event
      if (info.event.extendedProps.isMakeUpDay) {
        const makeUpDayIndex = this.editedMakeUpDays.findIndex(
          (m) =>
            (m.actual_date || m.original_date) === dateStr &&
            m.name === info.event.title
        );

        if (makeUpDayIndex !== -1) {
          const makeUpDay = this.editedMakeUpDays[makeUpDayIndex];
          this.makeUpDayForm = {
            name: makeUpDay.name,
            original_date: makeUpDay.original_date,
            actual_date: makeUpDay.actual_date,
            hour: makeUpDay.hour,
            comment: makeUpDay.comment || "",
          };
          this.editingMakeUpDayIndex = makeUpDayIndex;
          this.makeUpDayDialog = true;
        }
        return;
      }

      // Find the holiday in editedHolidays
      const holidayIndex = this.editedHolidays.findIndex(
        (h) =>
          (h.actual_date || h.original_date) === dateStr &&
          h.name === info.event.title
      );

      if (holidayIndex !== -1) {
        const holiday = this.editedHolidays[holidayIndex];
        this.eventForm = {
          name: holiday.name,
          original_date: holiday.original_date,
          actual_date: holiday.actual_date,
          comment: holiday.comment || "",
        };
        this.editingEventIndex = holidayIndex;
        this.eventDialog = true;
      }
    },

    closeEventDialog() {
      this.eventDialog = false;
      this.eventForm = {
        name: "",
        original_date: "",
        actual_date: "",
        comment: "",
      };
      this.editingEventIndex = null;
      if (this.$refs.eventForm) {
        this.$refs.eventForm.resetValidation();
      }
    },

    saveEvent() {
      if (!this.$refs.eventForm.validate()) {
        return;
      }

      const newHoliday = {
        name: this.eventForm.name,
        original_date: this.eventForm.original_date,
        actual_date: this.eventForm.actual_date,
        comment: this.eventForm.comment,
      };

      if (this.editingEventIndex !== null) {
        // Update existing holiday
        this.editedHolidays.splice(this.editingEventIndex, 1, newHoliday);
      } else {
        // Add new holiday
        this.editedHolidays.push(newHoliday);
      }

      // Update calendar display
      this.holidays = JSON.parse(JSON.stringify(this.editedHolidays));
      this.updateCalendarEvents();
      this.closeEventDialog();
    },

    deleteEvent() {
      if (this.editingEventIndex !== null) {
        this.editedHolidays.splice(this.editingEventIndex, 1);
        this.holidays = JSON.parse(JSON.stringify(this.editedHolidays));
        this.updateCalendarEvents();
        this.closeEventDialog();
      }
    },

    openMakeUpDayDialog() {
      this.makeUpDayForm = {
        name: "",
        original_date: "",
        actual_date: "",
        hour: "",
        comment: "",
      };
      this.editingMakeUpDayIndex = null;
      this.makeUpDayDialog = true;
    },

    closeMakeUpDayDialog() {
      this.makeUpDayDialog = false;
      this.makeUpDayForm = {
        name: "",
        original_date: "",
        actual_date: "",
        hour: "",
        comment: "",
      };
      this.editingMakeUpDayIndex = null;
      if (this.$refs.makeUpDayForm) {
        this.$refs.makeUpDayForm.resetValidation();
      }
    },

    saveMakeUpDay() {
      if (!this.$refs.makeUpDayForm.validate()) {
        return;
      }

      const newMakeUpDay = {
        name: this.makeUpDayForm.name,
        original_date: this.makeUpDayForm.original_date,
        actual_date: this.makeUpDayForm.actual_date,
        hour: this.makeUpDayForm.hour,
        comment: this.makeUpDayForm.comment,
      };

      if (this.editingMakeUpDayIndex !== null) {
        this.editedMakeUpDays.splice(
          this.editingMakeUpDayIndex,
          1,
          newMakeUpDay
        );
      } else {
        this.editedMakeUpDays.push(newMakeUpDay);
      }

      this.makeUpDays = JSON.parse(JSON.stringify(this.editedMakeUpDays));
      this.updateCalendarEvents();
      this.closeMakeUpDayDialog();
    },

    deleteMakeUpDay() {
      if (this.editingMakeUpDayIndex !== null) {
        this.editedMakeUpDays.splice(this.editingMakeUpDayIndex, 1);
        this.makeUpDays = JSON.parse(JSON.stringify(this.editedMakeUpDays));
        this.updateCalendarEvents();
        this.closeMakeUpDayDialog();
      }
    },
  },
};
</script>

<style scoped>
.year-selector {
  min-width: 120px;
}

.legend-box {
  width: 20px;
  height: 20px;
  border-radius: 4px;
}

.weekend-tip {
  background-color: rgba(160, 245, 167, 0.3) !important;
}

/* 週末整個單元格背景 */
/deep/.fc-daygrid-day.weekend-day {
  background-color: rgba(160, 245, 167, 0.15) !important;
}

/* /deep/.fc-daygrid-day.weekend-day .fc-daygrid-day-frame {
  background-color: rgba(76, 175, 80, 0.15) !important;
} */
/* 
/deep/.fc-daygrid-day.weekend-day .fc-daygrid-day-top {
  background-color: rgba(76, 175, 80, 0.15) !important;
} */

/deep/.fc-daygrid-day.weekend-day .fc-daygrid-day-events {
  background-color: transparent !important;
}

/deep/.fc-daygrid-day.weekend-day .fc-daygrid-day-bg {
  background-color: rgba(245, 243, 219, 0.15) !important;
}

/* 國定假日整個單元格背景 */
/* /deep/.fc-daygrid-day.holiday-day {
  background-color: rgba(244, 67, 54, 0.15) !important;
}

/deep/.fc-daygrid-day.holiday-day .fc-daygrid-day-frame {
  background-color: rgba(244, 67, 54, 0.15) !important;
}

/deep/.fc-daygrid-day.holiday-day .fc-daygrid-day-top {
  background-color: rgba(244, 67, 54, 0.15) !important;
}

/deep/.fc-daygrid-day.holiday-day .fc-daygrid-day-bg {
  background-color: rgba(244, 67, 54, 0.15) !important;
} */

/* 週末日期數字顏色 */
/* /deep/.fc-daygrid-day.weekend-day .fc-daygrid-day-number {
  color: #7d7c2e !important;
  font-weight: 600;
} */

/* 國定假日日期數字顏色 */
>>> .fc-daygrid-day.holiday-day .fc-daygrid-day-number {
  color: #f44336 !important;
  font-weight: 700;
}

/* 補班事件樣式 - 藍色底白字 */
/deep/.fc-event.make-up-day-event {
  background-color: #1976d2 !important;
  border-color: #1976d2 !important;
  color: white !important;
}

/deep/.fc-event.make-up-day-event .fc-event-title {
  color: white !important;
}

/deep/.fc-event.make-up-day-event .fc-event-main {
  color: white !important;
}
</style>
